/* Cache local de l'identité passager (prénom + téléphone) pour éviter de
   ressaisir à chaque visite. 100 % côté appareil (localStorage), aucune donnée
   envoyée ailleurs. Fenêtre glissante : purge automatique après `maxDays` jours
   d'inactivité. On ne stocke QUE prénom + téléphone (pas de hash serveur). */
const KEY = "gocab_boost_client";
const DAY_MS = 24 * 3600 * 1000;

export function saveClient({ firstName, phone }) {
  try {
    if (!firstName || !phone) return;
    localStorage.setItem(KEY, JSON.stringify({ firstName, phone, ts: Date.now() }));
  } catch (_) {
    /* localStorage indisponible (mode privé, quota) → on ignore */
  }
}

export function loadClient(maxDays = 7) {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const c = JSON.parse(raw);
    if (!c || !c.firstName || !c.phone || !c.ts) return null;
    if (Date.now() - c.ts > maxDays * DAY_MS) {
      localStorage.removeItem(KEY); // expiré → déconnexion
      return null;
    }
    return { firstName: c.firstName, phone: c.phone };
  } catch (_) {
    return null;
  }
}

export function clearClient() {
  try {
    localStorage.removeItem(KEY);
  } catch (_) {
    /* no-op */
  }
}
